import React, { useRef, useState } from "react";
import { CheckCircle2, FileSearch, Sparkles } from "lucide-react";
import { practiceApi } from "../../lib/practiceApi";
import "./coordination.css";

export const SiteVerify = ({ siteId, onSaved, testId = "site-verify" }) => {
  const [results, setResults] = useState([]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const inputRef = useRef();

  async function verify(event) {
    const files = Array.from(event.target.files || []);
    event.target.value = "";
    if (!files.length) return;
    setBusy(true); setError(""); setResults([]);
    const form = new FormData();
    files.forEach(file => form.append("files", file));
    try {
      const outcome = await practiceApi(`/coordination/${siteId}/ai-verify`, { method: "POST", body: form });
      setResults(outcome.results || []);
      onSaved();
    } catch (err) { setError(err.message); } finally { setBusy(false); }
  }

  return <div className="company-verify site-verify" data-testid={testId}>
    <div className="company-verify-head">
      <div>
        <strong><FileSearch size={14} />Verifica massiva del cantiere</strong>
        <small>Carica insieme i documenti di tutte le imprese: INGEGO AI riconosce impresa e adempimento e li smista da solo.</small>
      </div>
      <button className="ai-action" disabled={busy} data-testid={`${testId}-upload`} onClick={() => inputRef.current?.click()}>
        <Sparkles size={14} />{busy ? "Smisto i documenti…" : "Smista con INGEGO AI"}
      </button>
      <input type="file" multiple ref={inputRef} style={{ display: "none" }} onChange={verify} data-testid={`${testId}-input`} />
    </div>
    {error && <div className="error" role="alert" data-testid={`${testId}-error`}>{error}</div>}
    {!!results.length && <ul className="company-verify-results" data-testid={`${testId}-results`}>
      {results.map((row, index) => <li key={`${row.filename}-${index}`} className={row.verified ? "ok" : "todo"} data-testid={`${testId}-result-${index}`}>
        {row.verified ? <CheckCircle2 size={13} /> : <FileSearch size={13} />}
        <strong>{row.filename}</strong>
        <span>{row.message}{row.expiry_date ? ` · scade il ${row.expiry_date.split("-").reverse().join("/")}` : ""}</span>
      </li>)}
    </ul>}
  </div>;
};
